import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import useGetMoneyPoolManagement from '../fundPage/hooks/useGetMoneyPoolManagement'
import posthog from 'posthog-js'
import useGetUserInfo from './hooks/useGetUserInfo'
import Header from 'components/headers/bulletins'
import DotsLoading from 'components/loadings/dotsLoading'
import UserInfo from 'modules/financialHistory/userInfo'
import CustomTabs from 'modules/financialHistory/tabs'

export default function FinancialHistory() {
    const { moneyPool, poolship } = useParams()
    const { moneyPoolManagement, isLoadingMoneypoolManagement } =
        useGetMoneyPoolManagement(moneyPool)
    const role = moneyPoolManagement?.poolship?.role
    const isManager = role === 'mgr' || role === 'own'
    const { userInfo, isLoadingUserInfo } = useGetUserInfo()
    useEffect(() => {
        posthog.capture('member_detail_viewed', {
            fund_id: moneyPool,
            poolship_id: poolship,
        })
    }, [moneyPool, poolship])
    // pwa#36: «در حال حاضر پروفایل کاربر رو توی تب صندوق‌ها مدیر همونطوری
    // می‌بینه که بقیه می‌بینن. نباید اینطور باشه.» A manager arriving here from
    // any of the old links — the fund page, the followup modal, a bookmark —
    // lands on کارنامهٔ عضو instead. A plain member keeps this screen, which
    // is their own record and was never the thing being complained about.
    // `replace` so the phone's back button leaves the fund rather than
    // bouncing between the two screens.
    if (isManager) {
        return (
            <Navigate
                replace
                to={`/fund/member-record/${moneyPool}/${poolship}`}
            />
        )
    }

    // Deciding before the role is known would flash the old screen at a
    // manager for one frame on every open.
    if (isLoadingMoneypoolManagement) {
        return (
            <div className=" bg-white min-h-screen">
                <Header title="سابقه مالی عضو" />
                <DotsLoading />
            </div>
        )
    }

    return (
        <div className=" bg-white min-h-screen">
            <Header title="سابقه مالی عضو" />
            {isLoadingUserInfo ? (
                <DotsLoading />
            ) : (
                userInfo && <UserInfo data={userInfo} />
            )}
            <CustomTabs />
        </div>
    )
}
